export default "__VITE_ASSET__Rl9NPOY$__"